import styled from 'styled-components';
import { AppStoreButton } from './AppStroreButton';
import { useTheme } from '@material-ui/core';

export interface StoreButtonsProps {
  height?: string | number;
  width?: string | number;
}
export const StoreButtonsRoot = styled('div')(({ theme }) => ({
  '&.storeButtons': {
    display: 'flex',
    alignItems: 'center',
    gap: '16px',
  },
}));
export function StoreButtons(props: StoreButtonsProps) {
  const theme = useTheme();
  return (
    <StoreButtonsRoot className={'storeButtons'} theme={theme}>
      <AppStoreButton
        store="Android"
        height={props.height}
        width={props.width}
      />
      <AppStoreButton store="IOS" height={props.height} width={props.width} />
    </StoreButtonsRoot>
  );
}
